import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';

/**
 * Invito in sospeso nella Dashboard (FR-011, tavola 1A): chi invita, dove, ruoli proposti,
 * permesso e scadenza, con "Rifiuta" e "Rivedi e accetta".
 */
@Component({
  selector: 'bs-invitation-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, ButtonComponent, IconComponent],
  host: { class: 'block' },
  template: `
    <section
      class="flex flex-col gap-3 rounded-2xl bg-bsite-100 p-4 text-ink sm:flex-row sm:items-center dark:bg-bsite-950 dark:text-bsite-100"
      [attr.aria-label]="'Invito: ' + name()"
      [attr.data-testid]="testId()"
    >
      <span class="hidden sm:inline-flex" aria-hidden="true"
        ><bs-icon name="mail" [size]="22"
      /></span>
      <div class="flex min-w-0 flex-1 flex-col gap-0.5">
        <p class="font-semibold">
          {{ inviter() ?? 'Qualcuno' }}{{ accountName() ? ' di ' + accountName() : '' }} ti invita
          {{ scope() === 'project' ? 'nella commessa' : 'nel cantiere' }} «{{ name() }}»
        </p>
        <p class="text-sm">
          @if (proposedRoles().length > 0) {
            Ruolo proposto:
            <strong class="font-semibold">{{ proposedRoles().join(' · ') }}</strong> ·
          }
          {{ permission() }} · scade il
          <time class="font-mono" [attr.datetime]="expiresAt()">{{
            expiresAt() | date: 'dd/MM/yyyy'
          }}</time>
        </p>
      </div>
      <div class="flex flex-wrap gap-2">
        <bs-button
          variant="secondary"
          [disabled]="busy()"
          [testId]="testId() ? testId() + '-decline' : null"
          (click)="declined.emit()"
          >Rifiuta</bs-button
        >
        <bs-button
          variant="secondary"
          [link]="reviewLink()"
          [testId]="testId() ? testId() + '-review' : null"
          >Rivedi e accetta</bs-button
        >
      </div>
    </section>
  `,
})
export class InvitationBannerComponent {
  readonly name = input.required<string>();
  readonly scope = input<'site' | 'project'>('site');
  readonly inviter = input<string | null>(null);
  readonly accountName = input<string | null>(null);
  /** Etichette dei ruoli professionali proposti. */
  readonly proposedRoles = input<readonly string[]>([]);
  /** Permesso in parole, per esempio "Visualizzatore". */
  readonly permission = input.required<string>();
  readonly expiresAt = input.required<string>();
  readonly reviewLink = input.required<string | readonly unknown[]>();
  readonly busy = input(false);
  readonly testId = input<string | null>(null);
  readonly declined = output<void>();
}
